import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PremiumModal from './PremiumModal';
import { PremiumModalCopy } from '../types';

interface HeaderProps {
  onPremiumUnlocked: () => void;
  hasPremiumAccess: boolean;
}

const Header: React.FC<HeaderProps> = ({ onPremiumUnlocked, hasPremiumAccess }) => {
  const location = useLocation();
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [modalCopy, setModalCopy] = useState<PremiumModalCopy | undefined>();
  // Show "Go Premium" button on editor and privacy policy pages
  const showPremiumButton = !hasPremiumAccess && (location.pathname === '/editor' || location.pathname === '/privacy-policy');
  
  // Listen for global open event from banner clicks
  useEffect(() => {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<PremiumModalCopy | undefined>;
      setModalCopy(customEvent.detail || undefined);
      setShowPremiumModal(true);
    };
    window.addEventListener('openPremiumModal', handler as EventListener);
    return () => window.removeEventListener('openPremiumModal', handler as EventListener);
  }, []);

  const handleCloseModal = () => {
    setShowPremiumModal(false);
    setModalCopy(undefined);
  };

  const handleSuccess = () => {
    onPremiumUnlocked();
    // handleCloseModal();
  };

  return (
    <>
      <header className="header">
        <div className="container header__container">
          <Link to="/" className="logo">
            <img src="/img/logo.svg" alt="DesignsTattoo" />
          </Link>

          {showPremiumButton && (
            <button 
              className="header__btn"
              onClick={() => {
                setModalCopy(undefined);
                setShowPremiumModal(true);
              }}
            >
              <span>Go Premium</span>
            </button>
          )}
        </div>
      </header>

      {/* Premium Modal */}
      <PremiumModal 
        isOpen={showPremiumModal}
        onClose={handleCloseModal}
        onSuccess={handleSuccess}
        heading={modalCopy?.heading}
        description={modalCopy?.description}
        ctaLabel={modalCopy?.ctaLabel}
        successHeading={modalCopy?.successHeading}
        successMessage={modalCopy?.successMessage}
        showFeaturesList={modalCopy?.showFeaturesList}
      />
    </>
  );
};

export default Header;